import React, { ReactNode } from 'react';
import { IconSocialLikeOn16 } from '@cian/ui-kit-design-tokens/icons';

import * as s from './Label.css';

export interface ILabel {
  children: ReactNode;
}

/**
 * Компонент для величины рейтинга
 */
export const Label = ({ children }: ILabel) => (
  <div className={s['wrapper']}>
    <IconSocialLikeOn16 />
    {children}
  </div>
);
